import { useTranslation } from "react-i18next";
import type { AnalyticsSummaryDto } from "@normax-performance/shared-types";

export interface CompletenessSignalProps {
  workers: AnalyticsSummaryDto["workers"];
  completeness: AnalyticsSummaryDto["completeness"];
  isLoading: boolean;
}

/**
 * Data completeness (docs/NORMAX_PERFORMANCE_DASHBOARD_SLICE_C_IMPLEMENTATION_REPORT.md
 * §7) — pure typography, deliberately no bar/gauge (the zone-distribution
 * bar is this Dashboard's one allowed visualization, per its own policy).
 * Wording is restricted to what the schema can actually prove — never
 * "Odsutan"/"Nisu radili"/attendance language (`activeWorkerCount` only
 * ever means "not deactivated in Šifarnici", never "expected to work").
 */
export function CompletenessSignal({ workers, completeness, isLoading }: CompletenessSignalProps) {
  const { t } = useTranslation("dashboard");

  return (
    <div className="nx-dashboard__completeness">
      <p className="nx-dashboard__section-title">{t("completeness.title")}</p>
      {isLoading ? (
        <span className="nx-skeleton" style={{ width: "160px", height: "28px" }} />
      ) : (
        <>
          <p className="nx-dashboard__completeness-ratio">
            {t("completeness.recorded", { recorded: workers.recordedWorkerCount, active: workers.activeWorkerCount })}
          </p>
          <div className="nx-dashboard__completeness-detail">
            <span>{t("completeness.finished", { count: completeness.finishedEntryCount })}</span>
            <span>{t("completeness.draft", { count: completeness.draftEntryCount })}</span>
            <span>{t("completeness.withoutEntry", { count: completeness.activeWorkersWithoutEntryCount })}</span>
          </div>
        </>
      )}
    </div>
  );
}
